var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isActive)?_c('div',{staticClass:"spinner-border spinner-border-sm",attrs:{"role":"status"}}):_c('div',[_vm._v(_vm._s(_vm.defaultText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }